module.exports = __webpack_public_path__ + "static/peblett-79acb9ed397800b9111d07fb78b0b91a.png";